import { Link } from "react-router-dom";
import styled from "styled-components";

export const Btn = styled(Link)`
  width: 302px;
  height: 76px;
  min-height: 76px;
  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  box-shadow: 3px 7px 11px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
  color: var(--color-white);
  font-weight: 500;
  font-size: 17px;
  line-height: 1.3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
  padding: 0 18px 0 22px;
  text-decoration: none;
  margin: auto;
  word-break: break-word;
  hyphens: auto;

  .ptur-tildeOk-autocheckin {
    width: 38px;
    height: 28px;
    padding: 2px;
    flex-shrink: 0;
  }

  svg {
    flex-shrink: 0;
  }

  span {
    flex: 0.9;
    text-align: center;
  }

  /* Responsive: Tablet y Desktop */
  @media (min-width: 768px) {
    width: 100%;
    min-height: 90px;
    height: 90px;
    font-size: 20px;
    line-height: 1.4;
    padding: 0 28px 0 28px;
    gap: 16px;
  }

  @media (min-width: 1200px) {
    min-height: 100px;
    height: 100px;
    font-size: 19px;
    line-height: 1.3;
    padding: 0 24px 0 24px;
    gap: 16px;
  }
`;

export const BtnNormal = styled.button`
  width: 302px;
  height: 76px;
  min-height: 76px;

  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  box-shadow: 3px 7px 11px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
  color: var(--color-white);
  font-weight: ${({ normalFont }) => (normalFont ? "400" : "500")};
  font-size: 17px;
  line-height: 1.3;
  display: flex;
  justify-content: ${({ textCentre }) =>
    textCentre ? "center" : "flex-start"};
  align-items: center;
  gap: 14px;
  padding: ${({ textCentre }) => (textCentre ? "0 18px" : "0 18px 0 22px")};
  text-decoration: none;
  margin: auto;
  word-break: break-word;
  hyphens: auto;

  ${({ spacingWord }) => (spacingWord ? "word-spacing: 10px;" : "")}

  .ptur-tildeOk-autocheckin {
    width: 38px;
    height: 28px;
    padding: 2px;
    flex-shrink: 0;
  }

  svg {
    flex-shrink: 0;
  }

  span {
    flex: 0.9;
    text-align: center;
  }

  /* Responsive: Tablet y Desktop */
  @media (min-width: 768px) {
    width: 100%;
    min-height: 90px;
    height: 90px;
    font-size: 20px;
    line-height: 1.4;
    padding: ${({ textCentre }) => (textCentre ? "0 28px" : "0 28px 0 28px")};
    gap: 16px;
  }

  @media (min-width: 1200px) {
    min-height: 100px;
    height: 100px;
    font-size: 19px;
    line-height: 1.3;
    padding: ${({ textCentre }) => (textCentre ? "0 28px" : "0 24px 0 24px")};
    gap: 16px;
  }
`;

export const BtnGreen = styled(BtnNormal)`
  background: var(--color-green-gradient);
`;
